import * as Sentry from '@sentry/vue'
// import {browserLog} from '@/helper/helper'

export const isApp = !!window.ReactNativeWebView

export const postAppMessage = message => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(message)
  } else {
    // browserLog('App environment required: "' + message + '"')
    Sentry.captureMessage('postAppMessage without app env: "' + message + '"')
  }
}

export const postAppAction = (name, params = null) => {
  postAppMessage(
    JSON.stringify({
      type: 'WebViewMessage',
      action: name,
      params: params
    })
  )
}

export const shareLink = shareData => {
  postAppAction('shareLink', shareData)
}

export const openLink = link => {
  isApp ? openLinkExternal(link) : openLinkInternal(link)
}

export const openLinkExternal = link => {
  postAppAction('openLink', link)
}

export const openLinkInternal = link => {
  link.uri && window.open(link.uri)
}

export const updateBadge = badge => {
  postAppAction('updateBadge', badge)
}

export const configPushNotifications = () => {
  postAppAction('configPushNotifications')
}

export const reactNativeLog = msg => {
  postAppAction('log', JSON.stringify({msg}))
}



// WEBPACK FOOTER //
// ./src/utils/ReactNative.js